import { Menu, TeamAvatar, UserAvatar } from '@pocketlaw/tetris';
export function MultiselectOperatorItem(props) {
    const { title, subtitle, type } = props;
    if (type === 'user') {
        return <UserAvatar size="sm" title={title} subtitle={subtitle}/>;
    }
    if (type === 'team') {
        return <TeamAvatar size="sm" truncate={false} title={title} subtitle={subtitle}/>;
    }
    return <Menu.ItemText truncate={false} primary={title} secondary={subtitle}/>;
}
